/* Not loaded on the storefront: the theme loads cart-drawer-component.min.js, a copy of this file. Shopify re-minifies .js assets into syntax iOS 13.0-13.3 cannot run, and serves .min.js files as they are. Make changes in cart-drawer-component.min.js. */
(() => {
  // app/scripts/common/component/cartNote.js
  var {
    debounceTime
  } = theme;
  var CartNote = class extends HTMLElement {
    constructor() {
      var _this$querySelector;
      super();
      const input = this.querySelector("[name=note]");
      this.lastSavedNote = input === null || input === void 0 ? void 0 : input.value;
      const saveAfterInput = debounceTime(() => {
        this.noteInputPending = false;
        this.saveNote(input.value);
      }, 1e3);
      input === null || input === void 0 || input.addEventListener("input", () => {
        this.noteInputPending = true;
        const status = this.querySelector("[data-note-status]");
        if (status) status.textContent = "";
        saveAfterInput();
      });
      (_this$querySelector = this.querySelector("[data-note-retry]")) === null || _this$querySelector === void 0 || _this$querySelector.addEventListener("click", () => {
        this.noteInputPending = false;
        this.saveNote(input.value);
      });
    }
    async saveNote(value) {
      if (!this.isSaving && value === this.lastSavedNote) return;
      this.queuedNote = value;
      if (this.isSaving) return;
      this.isSaving = true;
      const error = this.querySelector("[data-note-error]");
      const status = this.querySelector("[data-note-status]");
      const input = this.querySelector("[name=note]");
      const retry = this.querySelector("[data-note-retry]");
      if (status) status.textContent = "";
      while (this.queuedNote !== undefined) {
        const note = this.queuedNote;
        this.queuedNote = undefined;
        try {
          if (note !== this.lastSavedNote) {
            const result = await window.fetch(`${theme.routes.cartUrl}/update.js`, {
              method: "POST",
              credentials: "same-origin",
              headers: {
                "X-Requested-With": "XMLHttpRequest",
                "Content-Type": "application/json;"
              },
              body: JSON.stringify({
                note
              })
            });
            const response = await result.json();
            if (!result.ok || response.status || String(response.note || "") !== note) throw new Error("Cart note was not saved");
            this.lastSavedNote = note;
          }
          if (error) error.hidden = true;
          input.removeAttribute("aria-describedby");
          if (retry) {
            if (document.activeElement === retry) input.focus();
            retry.hidden = true;
          }
          if (status && this.queuedNote === undefined && !this.noteInputPending && input.value === note) status.textContent = this.dataset.noteSaved || "";
        } catch (failure) {
          this.lastSavedNote = undefined;
          if (error) {
            error.hidden = false;
            input.setAttribute("aria-describedby", error.id);
          }
          if (retry) retry.hidden = false;
          if (status) status.textContent = "";
        }
      }
      this.isSaving = false;
    }
  };
  customElements.define("cart-note", CartNote);

  // app/scripts/common/component/cartRemove.js
  var CartRemoveButton = class extends HTMLElement {
    connectedCallback() {
      const link = this.querySelector("a");
      link.addEventListener("click", event => {
        try {
          event.preventDefault();
          let {
            key,
            sections,
            sections_url
          } = link.dataset;
          if (!key) return;
          sections = [sections];
          this.closest("cart-component,cart-drawer-component").dispatchEvent(new CustomEvent("change", {
            bubbles: true,
            detail: {
              customElement: {
                target: link,
                key,
                quantity: 0,
                sections,
                sections_url
              }
            }
          }));
        } catch (e) {
          console.log(e);
        }
      });
    }
  };
  customElements.define("cart-remove-button", CartRemoveButton);

  // app/scripts/common/component/cartUpdateComponent.js
  !customElements.get("cart-update-component") && customElements.define("cart-update-component", class extends cartForm {
    constructor() {
      super();
      this.addEventListener("change", e => {
        this.currentTarget = e.target;
        let {
          value
        } = this.currentTarget;
        if (this.currentTarget.type == "checkbox") {
          value = this.currentTarget.checked;
        }
        this.onUpdate(value);
        if (this.querySelector(".jsValue")) this.querySelector(".jsValue").innerHTML = this.currentTarget.dataset.value || value;
      });
    }
    onUpdate(value) {
      const attributes = {
        [this.dataset.type]: value
      };
      this.disabled = true;
      // A save that fails gives the control back (LIVE-112): it was left unclickable.
      this.cartUpdate(attributes).catch(() => {
        this.disabled = false;
      });
    }
    set disabled(value) {
      this.classList.toggle("event-none", value);
    }
    set setValue(element) {
      this.currentTarget = element;
      let {
        value
      } = element;
      if (element.type == "checkbox") {
        value = element.checked;
      }
      this.onUpdate(value);
      if (this.querySelector(".jsValue")) this.querySelector(".jsValue").innerHTML = element.dataset.value || value;
    }
    async onFinished() {
      this.updateState();
      this.disabled = false;
    }
    async updateState() {
      var _this$closest;
      const {
        sectionId
      } = this.dataset;
      if (!sectionId) return;
      let url = location.href;
      url += url.includes("?") ? "&" : "?";
      url += sectionId;
      let html = await fetch(url);
      html = await html.text();
      const div = document.createElement("div");
      div.innerHTML = html;
      (_this$closest = this.closest("filter-component")) === null || _this$closest === void 0 || _this$closest.render(div);
      if (this.currentTarget.closest("details[open]") && this.currentTarget.closest("filter-component") && window.matchMedia("(max-width: 991px)").matches) return;
      if (this.currentTarget.closest("details[open]")) this.currentTarget.closest("details[open]").open = false;
    }
  });

  // app/scripts/cart-drawer-component.js
  var {
    debounceTime: debounceTime2
  } = theme;
  var cartDrawerComponent = class extends cartForm {
    constructor() {
      super();
      this.addEventListener("change", this.onChange.bind(this));
    }
    set open(value) {
      const popup = this.closest("popup-component");
      if (value) {
        this.closeAllCurrentPopups();
        popup.open();
      } else popup.close();
    }
    // A product form's Add to Cart draws the side cart from its own answer. It takes a number like any refresh, so an
    // older answer still on its way is dropped (LIVE-112), and a "could not confirm" from before no longer holds.
    set refresh(sections) {
      const div = document.createElement("div");
      div.innerHTML = sections[this.sectionName];
      const replacement = div.querySelector(this.tagName);
      if (!replacement || !this.cartMayDraw(this.cartTicket())) return;
      this.renderCartContent(replacement);
      this.clearCartRetry();
      this.setCartBusy(Boolean(this.isUpdating));
    }
    closeAllCurrentPopups() {
      var _document$querySelect;
      (_document$querySelect = document.querySelectorAll("popup-component.active")) === null || _document$querySelect === void 0 || _document$querySelect.forEach(popup => {
        popup.close();
      });
    }
  };
  customElements.define("cart-drawer-component", cartDrawerComponent);
  document.addEventListener("click", e => {
    if (!e.target.closest(".jsCartDrawer")) return;
    e.preventDefault();
    document.querySelector("cart-drawer-component").open = true;
  });
  // Klaviyo's sign-up popup waits while the side cart is open (cart-drawer.css hides it, LIVE-36). If it moves focus
  // to itself, focus goes back to where it was in the side cart. When the side cart closes (and puts focus back on its
  // opener), focus goes to the popup's close button, as Klaviyo would have done. Only where :has() works, since
  // without it the popup shows as before.
  if (window.CSS && CSS.supports && CSS.supports("selector(:has(*))")) {
    const klaviyoPopup = 'div[role="dialog"][aria-modal="true"][class*="kl-private-reset"]';
    let lastInCart = null;
    let cartWasOpen = false;
    document.addEventListener("focusin", e => {
      const drawer = document.getElementById("cartDrawer");
      if (!drawer) return;
      if (drawer.getAttribute("aria-hidden") !== "false") {
        if (!cartWasOpen) return;
        cartWasOpen = false;
        setTimeout(() => {
          const popup = document.querySelector(klaviyoPopup);
          if (!popup || popup.contains(document.activeElement) || drawer.getAttribute("aria-hidden") === "false") return;
          const target = popup.querySelector(".klaviyo-close-form") || popup.querySelector("button, input, a[href]");
          if (target) target.focus();
        }, 0);
        return;
      }
      cartWasOpen = true;
      if (drawer.contains(e.target)) {
        lastInCart = e.target;
        return;
      }
      if (e.target.closest && e.target.closest(klaviyoPopup)) (lastInCart && lastInCart.isConnected && drawer.contains(lastInCart) ? lastInCart : drawer).focus();
    });
  }
})();
